import {MaximumOrderQuantityRestDto} from "@/api/pharma-cpc-product-mgmt/models";

export class MaximumOrderQuantityRestDtoModel implements MaximumOrderQuantityRestDto {
    max_per_order?: number;

    constructor(max_per_order: number | undefined) {
        this.max_per_order = max_per_order;
    }

    static createWithDefaults(): MaximumOrderQuantityRestDtoModel {
        return new this(undefined);
    }
}
